<template>
  <div>
    <!-- Header -->
    <div class="header py-7 pt-lg-9">
      <b-container class="container">
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <div v-if="$route.query.pulse" class="pb-4">
                <img src="/img/pulse/pulse-logo-white.png" style="width: 200px;">
                <h3 class="mt-2">Powered by ClarityNOW</h3>
              </div>
              <h1 class="text-white" style="text-shadow: 1px 0px #000;">Sign up and get Clarity on your business NOW!</h1>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
    <!-- Page content -->
    <b-container class="mt--9 pb-5">
      <!-- Table -->
      <validation-observer v-slot="{handleSubmit}" ref="formValidator">
        <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
          <div v-if="step == 0">
            <div id="pricing-table" v-if="products.length > 0">
              <div class="justify-content-center d-flex mb-3">
                <h3 class="mr-3 text-white" style="z-index:999;">MONTHLY</h3>
                <base-switch type="white" onText="" offText="" class="mr-1" v-model="term"></base-switch>
                <h3 class="ml-3 text-white" style="z-index:999;">ANNUALLY</h3>
              </div>
              <b-row class="justify-content-center">
                <b-col md="4" v-if="!$route.query.payment_required">
                  <b-card body-class="d-flex flex-column" class="plans">
                    <b-card-title class="text-center">
                      Pro
                    </b-card-title>
                    <b-card-text>
                      <h3 class="text-center" v-if="!term">${{ products[0].monthly_price.price / 100 }}/month</h3>
                      <h3 class="text-center" v-if="term">${{ products[0].yearly_price.price / 100 }}/year</h3>
                      <div class="text-center my-3">
                        <b-button block variant="danger" @click="selectPlan(products[0])">Select Plan</b-button>
                      </div>
                      <h5 class="pl-2">FEATURES</h5>
                      <ul class="pl-4">
                        <li>Input Unlimited Listings & Transactions</li>
                        <li>Pipeline Report</li>
                        <li>Profit Based Economic Model</li>
                        <li>CEO Monthly Summary Reports</li>
                        <li>Unlimited Users (edit and view only)</li>
                      </ul>
                      <h5 class="pl-2">ENHANCED BUSINESS PLANNING</h5>
                      <ul class="pl-4">
                        <li>Profit-Based Economic Model</li>
                        <li>Budget Model</li>
                        <li>Lead Generation Model</li>
                      </ul>
                      <h5 class="pl-2">ENHANCED PRODUCTION TOOLS</h5>
                      <ul class="pl-4">
                        <li>Daily Tracking</li>
                        <li>Expense Logs</li>
                        <li>Custom Lead Source Tracking</li>
                      </ul>
                      <h5 class="pl-2">ENHANCED CEO TOOLS & REPORTS</h5>
                      <ul class="pl-4">
                        <li>Add Users (agents, editors, viewers)</li>
                        <li>Production Goal/Gap Planning and Reporting</li>
                        <li>Agent Summary Reports</li>
                        <li>Projected Net Profit Reports</li>
                        <li>Year-Over-Year Reports</li>
                        <li>Profit & Loss Reports</li>
                      </ul>
                      <h5 class="pl-2">ENHANCED TEAM COMMUNICATION</h5>
                      <ul class="pl-4">
                        <li>Tag & Update Team Members</li>
                        <li>Add Important Notes in Agents' Pipelines</li>
                      </ul>
                      <h5 class="pl-2">PLUS</h5>
                      <ul class="pl-4">
                        <li>Access the ClarityNOW Community (Coming Soon)</li>
                        <li>Live Support</li>
                      </ul>
                      <hr />
                      <h3 class="pl-2">$10 Per Agent Access</h3>
                    </b-card-text>
                  </b-card>
                </b-col>

                <b-col md="4">
                  <b-card body-class="d-flex flex-column" id="business-plus-plan" class="plans">
                    <b-card-title class="text-center">
                      Business+
                    </b-card-title>
                    <b-card-text>
                      <h3 class="text-center" v-if="!term">${{ products[1].monthly_price.price / 100 }}/month</h3>
                      <h3 class="text-center" v-if="term">${{ products[1].yearly_price.price / 100 }}/year</h3>
                      <div class="text-center my-3">
                        <b-button block variant="danger" @click="selectPlan(products[1])">Select Plan</b-button>
                      </div>
                      <h5 class="pl-2">FEATURES</h5>
                      <ul class="pl-4">
                        <li>All <strong>Pro</strong> features, plus</li>
                      </ul>
                      <h5 class="pl-2">ENHANCED CEO TOOLS & REPORTS</h5>
                      <ul class="pl-4">
                        <li>Conversion Reports</li>
                        <li>Agent Production Reports</li>
                        <li>Lead Source Reports</li>
                        <li>Vendor Reports</li>
                      </ul>
                      <hr />
                      <h3 class="pl-2">$5 Per Agent Access</h3>
                    </b-card-text>
                  </b-card>
                </b-col>
              </b-row>
            </div>
            <div v-else>
              <loading-panel></loading-panel>
            </div>

          </div>

          <div v-if="step == 1">
            <b-row class="justify-content-center">
              <b-col lg="10" md="12">
                <b-card>
                  <b-card-body>
                    <b-row>
                      <b-col md="6" class="border-right pr-5">
                        <div class="text-center text-muted mb-4">
                          <h2>Registration</h2>
                          <small>Have an account? Then please <a href="/">Login Here</a></small>
                        </div>
                        <base-input alternative
                                    class="mb-3"
                                    prepend-icon="ni ni-hat-3"
                                    placeholder="Name"
                                    name="Name"
                                    :rules="{required: true}"
                                    v-model="model.name">
                        </base-input>

                        <base-input alternative
                                    class="mb-3"
                                    prepend-icon="ni ni-email-83"
                                    placeholder="Email"
                                    name="Email"
                                    :rules="{required: true, email: true}"
                                    v-model="model.email">
                        </base-input>

                        <base-input alternative
                                    class="mb-3"
                                    prepend-icon="ni ni-lock-circle-open"
                                    placeholder="Password"
                                    type="password"
                                    name="Password"
                                    :rules="{required: true, min: 6}"
                                    v-model="model.password"
                                    ref="password">
                        </base-input>
                        <base-input alternative
                                    class="mb-3"
                                    prepend-icon="ni ni-lock-circle-open"
                                    placeholder="Confirm Password"
                                    type="password"
                                    name="Confirm Password"
                                    :rules="{required: true, min: 6, is: model.password}"
                                    v-model="model.password_confirmation">
                        </base-input>
                        <div class="text-center">
                          <b-button block variant="danger" @click="step = 2">NEXT</b-button>
                        </div>
                      </b-col>
                      <b-col md="6" class="pl-5 mt-2">
                        <h3>Selected Plan</h3>
                        <div class="d-flex justify-content-between align-items-center">
                          <span class="h1">{{ selected.name }}</span>
                          <div>
                            <span class="h2 mb-0" v-if="!term">{{ selected.monthly_price.price / 100 | currency }}</span>
                            <span class="h2 mb-0" v-else>{{ selected.yearly_price.price / 100 | currency }}</span>
                          </div>
                        </div>
                        <div class="pb-2 border-bottom"></div>
                        <b-row class="mb-2">
                          <b-col>                              
                            <div class="mt-3">
                              <b-form-group size="sm" label="Coupon Code:" label-for="coupon" label-class="form-control-label" class="mb-0" v-if="model.enterprise.length == 0">
                                <b-input-group>
                                  <b-form-input placeholder="CLARITYNOW" v-model="promocode"></b-form-input>
                                  <template #append>
                                    <b-button variant="success" @click="checkCoupon">Apply</b-button>
                                  </template>
                                </b-input-group>
                                <b-form-text id="input-live-help" v-if="valid_coupon == false"><span class="text-danger">Invalid coupon code.</span></b-form-text>
                                <b-form-text id="input-live-help" v-if="valid_coupon"><span class="text-success">Coupon has been applied successfully.</span></b-form-text>
                              </b-form-group>
                            </div>
                          </b-col>
                        </b-row>
                        <b-row class="mt-4 pt-4 border-top">
                          <b-col class="p-3 bg-light-blue">
                            <div class="d-flex justify-content-between align-items-center" v-if="model.enterprise.length > 0">
                              <div class="mb-3">
                                <h4 class="bold mb-0">Enterprise:</h4>
                                <span class="bold">Enterprise User</span>
                              </div>
                              <span class="text-danger">100% OFF</span>
                            </div>
                            <div class="d-flex justify-content-between align-items-center" v-if="valid_coupon">
                              <div class="mb-3">
                                <h4 class="bold mb-0">Promotion:</h4>
                                <span class="bold">{{ promocode }}</span>
                              </div>
                              <span class="text-danger" v-if="coupon.coupon.amount_off > 0">{{ coupon.coupon.amount_off / 100 | currency }} OFF</span>
                              <span class="text-danger" v-else>{{ coupon.coupon.percent_off }}% OFF</span>
                            </div>
                            <div class="d-flex justify-content-between align-items-center mb-2">
                              <span class="bold">Total due today:</span>
                              <div>
                                <span class="h2 mb-0" v-if="!term">{{ monthlyPrice | currency }}</span>
                                <span class="h2 mb-0" v-else>{{ yearlyPrice | currency }}</span>
                              </div>
                            </div>

                            <p class="small" v-if="!term">*Recurring monthly costs with be <strong>{{ monthlyPrice | currency }}</strong>.</p>
                            <p class="small" v-else>*Recurring monthly costs with be <strong>{{ monthlyPrice | currency }}</strong>.</p>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </div>

          <div v-if="step == 2">
            <b-row class="justify-content-center">
              <b-col lg="10" md="12">
                <b-card>
                  <b-card-body>
                    <b-row>
                      <b-col md="6" class="border-right pr-5">
                        <div v-if="!showLoginForm">
                          <div class="text-center text-muted mb-4">
                            <h2>Registration</h2>
                            <small>Have an account? Then please <a href="/">Login Here</a></small>
                          </div>

                          <base-input alternative
                                      class="mb-3"
                                      prepend-icon="ni ni-map-big"
                                      placeholder="City"
                                      name="City"
                                      :rules="{required: true}"
                                      v-model="model.city">
                          </base-input>

                          <base-input>
                            <state-select v-model="model.state" :required="true"></state-select>
                          </base-input>

                          <base-input alternative
                                      class="mb-3"
                                      prepend-icon="ni ni-mobile-button"
                                      placeholder="Phone"
                                      name="Phone"
                                      :rules="{required: true}"
                                      v-model="model.phone">
                          </base-input>

                          
                          <base-input alternative
                                      class="mb-3"
                                      prepend-icon="ni ni-hat-3"
                                      placeholder="e.g. Company or Team Name"
                                      name="Team Name"
                                      :rules="{required: true}"
                                      v-model="model.team">
                          </base-input>
                          <base-input label-for="team_member" name="Realty Role">
                            <el-select v-model="model.realty_role" placeholder="Select Real Estate Role">
                              <el-option v-for="(role, index) in roles"
                                         :key="index"
                                         :label="role.text"
                                         :value="role.value">
                              </el-option>
                            </el-select>
                          </base-input>

                          <div v-if="errors">
                            <ul class="text-danger">
                              <li v-for="(error, index) in errors" :key="index" class="small">
                                {{ error.toString() }}
                              </li>
                            </ul>
                          </div>

                          <b-button block variant="outline-danger" @click="showLoginForm = true" v-if="errors">Login</b-button>
                          <div class="text-center mt-4 d-flex" v-else>
                            <b-button variant="outline-danger" @click="step = 1" class="flex-fill">BACK</b-button>
                            <b-button type="submit" variant="danger" :disabled="disabled" class="flex-fill"><span v-html="registerBtn"></span></b-button>
                          </div>
                        </div>
                        <div v-else>
                          <div class="text-center text-muted mb-4">
                            <h2>Login</h2>

                            <base-input alternative
                                        class="mb-3"
                                        name="Email"
                                        :rules="{required: true, email: true}"
                                        prepend-icon="ni ni-email-83"
                                        placeholder="Email"
                                        v-model="loginForm.email">
                            </base-input>

                            <base-input alternative
                                        class="mb-3"
                                        name="Password"
                                        :rules="{required: true, min: 6}"
                                        prepend-icon="ni ni-lock-circle-open"
                                        type="password"
                                        placeholder="Password"
                                        v-model="loginForm.password">
                            </base-input>

                            <b-button block variant="success" @click="login(loginForm.email, loginForm.password)">Login</b-button>
                          </div>
                        </div>
                      </b-col>
                      <b-col md="6" class="pl-5 mt-2">
                        <h3>Selected Plan</h3>
                        <div class="d-flex justify-content-between align-items-center">
                          <span class="h1">{{ selected.name }}</span>
                          <div>
                            <span class="h2 mb-0" v-if="!term">{{ selected.monthly_price.price / 100 | currency }}</span>
                            <span class="h2 mb-0" v-else>{{ selected.yearly_price.price / 100 | currency }}</span>
                          </div>
                        </div>
                        <div class="pb-2 border-bottom"></div>
                        <b-row class="mb-2">
                          <b-col>                              
                            <div class="mt-3">
                              <b-form-group size="sm" label="Coupon Code:" label-for="coupon" label-class="form-control-label" class="mb-0" v-if="model.enterprise.length == 0">
                                <b-input-group>
                                  <b-form-input placeholder="CLARITYNOW" v-model="promocode"></b-form-input>
                                  <template #append>
                                    <b-button variant="success" @click="checkCoupon">Apply</b-button>
                                  </template>
                                </b-input-group>
                                <b-form-text id="input-live-help" v-if="valid_coupon == false"><span class="text-danger">Invalid coupon code.</span></b-form-text>
                                <b-form-text id="input-live-help" v-if="valid_coupon"><span class="text-success">Coupon has been applied successfully.</span></b-form-text>
                              </b-form-group>
                            </div>
                          </b-col>
                        </b-row>
                        <b-row class="mt-4 pt-4 border-top">
                          <b-col class="p-3 bg-light-blue">
                            <div class="d-flex justify-content-between align-items-center" v-if="model.enterprise.length > 0">
                              <div class="mb-3">
                                <h4 class="bold mb-0">Enterprise:</h4>
                                <span class="bold">Enterprise User</span>
                              </div>
                              <span class="text-danger">100% OFF</span>
                            </div>
                            <div class="d-flex justify-content-between align-items-center" v-if="valid_coupon">
                              <div class="mb-3">
                                <h4 class="bold mb-0">Promotion:</h4>
                                <span class="bold">{{ promocode }}</span>
                              </div>
                              <span class="text-danger" v-if="coupon.coupon.amount_off > 0">{{ coupon.coupon.amount_off / 100 | currency }} OFF</span>
                              <span class="text-danger" v-else>{{ coupon.coupon.percent_off }}% OFF</span>
                            </div>
                            <div class="d-flex justify-content-between align-items-center mb-2">
                              <span class="bold">Total due today:</span>
                              <div>
                                <span class="h2 mb-0" v-if="!term">{{ monthlyPrice | currency }}</span>
                                <span class="h2 mb-0" v-else>{{ yearlyPrice | currency }}</span>
                              </div>
                            </div>
                            <p class="small" v-if="!term">*Recurring monthly costs with be <strong>{{ monthlyPrice | currency }}</strong>.</p>
                            <p class="small" v-else>*Recurring monthly costs with be <strong>{{ monthlyPrice | currency }}</strong>.</p>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </b-form>
      </validation-observer>

      <div v-if="step == 3">
        <b-row class="justify-content-center">
          <b-col lg="10" md="12">
            <b-card>
              <b-card-body>
                <b-row>
                  <b-col md="6" class="border-right pr-5">
                    <div class="text-center text-muted mb-4">
                      <h2>Registration</h2>
                      <small>Have an account? Then please <a href="/">Login Here</a></small>
                    </div>
                    <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                      <b-form role="form">
                        <b-row>
                          <b-col>
                            <label for="card-holder-name" class="sr-only sr-only-focusable">Name on Card</label>
                            <base-input name="Name on Card"
                                        placeholder="Card Holder Name"
                                        rules="required"
                                        v-model="name">
                            </base-input>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <div id="card-element" class="form-control"></div>
                          </b-col>
                        </b-row>
                        <b-row class="mt-3">
                          <b-col cols="12">
                            <base-input :rules="{ required: { allowFalse: false } }" name="Privacy Policy">
                              <b-form-checkbox v-model="auto_renewal">
                                <span class="text-muted">I agree with the <a href="https://www.claritynowre.com/privacy-policy" target="_blank">Privacy Policy</a></span>
                              </b-form-checkbox>
                            </base-input>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <small class="text-danger">
                              Automatic Renewal Notice: Your ClarityNOW membership will automatically renew every month and your membership will continue until you cancel. No minimum purchase required. Your credit card or selected payment method will be used for your membership, and will continue to be used monthly. You can cancel your membership or change your selected payment method at any time.
                            </small>
                          </b-col>
                        </b-row>
                        <div class="text-center mt-4 d-flex">
                          <b-button variant="outline-danger" @click="step = 2" class="flex-fill">BACK</b-button>
                          <b-button type="submit" variant="danger" :disabled="paymentDisabled" class="flex-fill" @click="submitPaymentMethod">SUBSCRIBE</b-button>
                        </div>
                      </b-form>
                    </validation-observer>
                  </b-col>
                  <b-col md="6" class="pl-5 mt-2">
                    <h3>Selected Plan</h3>
                    <div class="d-flex justify-content-between align-items-center">
                      <span class="h1">{{ selected.name }}</span>
                      <div>
                        <span class="h2 mb-0" v-if="!term">{{ selected.monthly_price.price / 100 | currency }}</span>
                        <span class="h2 mb-0" v-else>{{ selected.yearly_price.price / 100 | currency }}</span>
                      </div>
                    </div>
                    <div class="pb-2 border-bottom"></div>
                    <b-row class="mb-2">
                      <b-col>                              
                        <div class="mt-3">
                          <b-form-group size="sm" label="Coupon Code:" label-for="coupon" label-class="form-control-label" class="mb-0" v-if="model.enterprise.length == 0">
                            <b-input-group>
                              <b-form-input placeholder="CLARITYNOW" v-model="promocode"></b-form-input>
                              <template #append>
                                <b-button variant="success" @click="checkCoupon">Apply</b-button>
                              </template>
                            </b-input-group>
                            <b-form-text id="input-live-help" v-if="valid_coupon == false"><span class="text-danger">Invalid coupon code.</span></b-form-text>
                            <b-form-text id="input-live-help" v-if="valid_coupon"><span class="text-success">Coupon has been applied successfully.</span></b-form-text>
                          </b-form-group>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="mt-4 pt-4 border-top">
                      <b-col class="p-3 bg-light-blue">
                        <div class="d-flex justify-content-between align-items-center" v-if="model.enterprise.length > 0">
                          <div class="mb-3">
                            <h4 class="bold mb-0">Enterprise:</h4>
                            <span class="bold">Enterprise User</span>
                          </div>
                          <span class="text-danger">100% OFF</span>
                        </div>
                        <div class="d-flex justify-content-between align-items-center" v-if="valid_coupon">
                          <div class="mb-3">
                            <h4 class="bold mb-0">Promotion:</h4>
                            <span class="bold">{{ promocode }}</span>
                          </div>
                          <span class="text-danger" v-if="coupon.coupon.amount_off > 0">{{ coupon.coupon.amount_off / 100 | currency }} OFF</span>
                          <span class="text-danger" v-else>{{ coupon.coupon.percent_off }}% OFF</span>
                        </div>
                        <div class="d-flex justify-content-between align-items-center mb-2">
                          <span class="bold">Total due today:</span>
                          <div>
                            <span class="h2 mb-0" v-if="!term">{{ monthlyPrice | currency }}</span>
                            <span class="h2 mb-0" v-else>{{ yearlyPrice | currency }}</span>
                          </div>
                        </div>
                        <p class="small" v-if="!term">*Recurring monthly costs with be <strong>{{ monthlyPrice | currency }}</strong>.</p>
                        <p class="small" v-else>*Recurring monthly costs with be <strong>{{ monthlyPrice | currency }}</strong>.</p>
                      </b-col>
                    </b-row>
                  </b-col> 
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import StateSelect from "@/views/Components/Forms/StateSelect";
import {Select, Option} from 'element-ui';
import errorsMixin from "@/mixins/errors-mixin";
import LoadingPanel from "@/components/LoadingPanel";

export default {
  name: 'register',
  mixins: [errorsMixin],
  components: {
    StateSelect,
    [Select.name]: Select,
    [Option.name]: Option,
    LoadingPanel
  },
  data() {
    return {
      model: {
        name: '',
        email: '',
        city: '',
        state: '',
        phone: '',
        password: '',
        password_confirmation: '',
        team: '',
        realty_role: null,
        affiliate: '',
        pulse: false,
        kwyp: false,
        enterprise: '',
        plan: ''
      },
      roles: [
        {
          value: 'Rainmaker',
          text: 'Rainmaker'
        },
        {
          value: 'Solo Agent',
          text: 'Solo Agent'
        },
        {
          value: 'Listing Agent',
          text: 'Listing Agent'
        },
        {
          value: 'Buyers Agent',
          text: 'Buyers Agent'
        },
        {
          value: 'Admin',
          text: 'Admin'
        },
        {
          value: 'ISA',
          text: 'ISA'
        },
        {
          value: 'Real Estate Coach',
          text: 'Real Estate Coach'
        },
        {
          value: 'Other',
          text: 'Other'
        },
      ],
      errors: null,
      registerBtn: 'REGISTER',
      disabled: false,
      paymentDisabled: false,
      step: 0,
      stripeAPIToken: '',
      intentToken: '',
      stripe: '',
      elements: '',
      card: '',
      selected: null,
      name: null,
      payment_method: null,
      auto_renewal: false,
      plan: null,
      products: [],
      promocode: null,
      coupon: null,
      valid_coupon: null,
      showLoginForm: false,
      loginForm: {
        email: '',
        password: ''
      },
      term: false,
      affiliateId: null,
    }
  },
  computed: {
    passwordConfirmed() {
      return this.model.password == this.model.confirm_password;
    },
    user() {
      return this.$store.getters['profile/user'];
    },
    userRoute() {
      return this.$store.getters['profile/userRoute'];
    },
    businessPlus() {
      return this.products.filter((product) => {
        return product.monthly_price.price == 9900;
      })[0];
    },
    authenticated() {
      return this.$store.getters['isAuthenticated'];
    },
    monthlyPrice() {
      if (this.model.enterprise.length > 0) {
        return 0;
      } else if (this.valid_coupon) {
        if (this.coupon.coupon.amount_off > 0) {
          return this.selected.monthly_price.price / 100 - this.coupon.coupon.amount_off;
        } else {
          return (this.selected.monthly_price.price / 100) * ((100 - this.coupon.coupon.percent_off) / 100); 
        }
      } else {
        return this.selected.monthly_price.price / 100;
      }
    },
    yearlyPrice() {
      if (this.model.enterprise.length > 0) {
        return 0;
      } else if (this.valid_coupon) {
        if (this.coupon.coupon.amount_off > 0) {
          return this.selected.yearly_price.price / 100 - this.coupon.coupon.amount_off;
        } else {
          return (this.selected.yearly_price.price / 100) * ((100 - this.coupon.coupon.percent_off) / 100); 
        }
      } else {
        return this.selected.yearly_price.price / 100;
      }
    }
  },
  methods: {
    async onSubmit() {
      this.disabled = true;
      this.registerBtn = '<i class="fas fa-spinner fa-pulse"></i> PROCESSING...';

      axios.post(process.env.VUE_APP_API_BASE_URL + "/register", this.model)
      .then(response => {
        this.login(this.model.email, this.model.password);
        this.partnerStackSignup();
      })
      .catch(error => {
        this.registerBtn = 'REGISTER';
        this.errors = error.response.data.errors;
        this.error(error);
      });
    },
    async login(email, password) {
      const user = {
        email: email,
        password: password
      }

      const requestOptions = {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
        },
      };

      try {
        await this.$store.dispatch("login", { user, requestOptions });        
        swal.fire({
          title: `Success`,
          text: 'Welcome to ClarityNOW!',
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.setupStore();

          if (this.$route.query.enterprise || !this.plan) {
            this.$router.push({
              path: '/home'
            });
          } else {
            this.step = 3;
          }
        });
      } catch(error) {
        this.error(error);
        this.setApiValidation(error.response.data.errors);
      }
    },
    partnerStackSignup() {
      growsumo.data.name = this.model.name;
      growsumo.data.email = this.model.email;
      growsumo.data.customer_key = this.model.email;
      growsumo.createSignup();
    },
    async getPlans() {
      axios.get(process.env.VUE_APP_API_BASE_URL + "/active-plans")
      .then(response => {
        this.products = response.data;

        if (this.$route.query.enterprise) {
          this.selected = this.products[1];
          this.model.plan = this.products[1].monthly_price.id;
          this.model.enterprise = this.$route.query.enterprise;
          this.step = 1;
        }
      })
      .catch(error => {
        this.error(error);
      });
    },
    async getStripeKey() {
      axios.get(process.env.VUE_APP_API_BASE_URL + '/stripe-key')
      .then(response => {
        this.stripeAPIToken = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    includeStripe(URL, callback){
      let documentTag = document, tag = 'script',
          object = documentTag.createElement(tag),
          scriptTag = documentTag.getElementsByTagName(tag)[0];
      object.src = '//' + URL;
      if (callback) { object.addEventListener('load', function (e) { callback(null, e); }, false); }
      scriptTag.parentNode.insertBefore(object, scriptTag);
    },
    configureStripe(){
      this.stripe = Stripe(this.stripeAPIToken);

      this.elements = this.stripe.elements();
      this.card = this.elements.create('card');

      this.card.mount('#card-element');
    },
    async submitPaymentMethod() {
      this.paymentDisabled = true;
      this.addPaymentStatus = 1;

      this.stripe.confirmCardSetup(
        this.intentToken.client_secret, {
          payment_method: {
            card: this.card,
            billing_details: {
                name: this.name
            }
          }
        }
      ).then(result => {
        if (result.error) {
          this.addPaymentStatus = 3;
          this.addPaymentStatusError = result.error.message;
          this.disabled = false;
        } else {
          this.payment_method = result.setupIntent.payment_method;
          this.subscribe();
        }
      });
    },
    async subscribe() {
      await axios.post(this.userRoute + "/subscribe", {
        payment_method: this.payment_method,
        plan: this.plan,
        coupon: this.coupon ? this.coupon.coupon.id : '',
        client_referral_id: this.affiliateId
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: 'Subscription Created Successfully',
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        }).then(result => {
          this.$router.push({
            path: '/home'
          });
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
    setupStore() {
      this.$store.dispatch("roles/get");
      this.$store.dispatch("teams/get", {user: this.user.slug});
      this.$store.dispatch("teams/member", {user: this.user.slug});
      this.getIntent();
    },
    async getIntent() {
      axios.get(this.userRoute + "/payment-setup")
      .then(response => {
        this.intentToken = response.data.intent;
      })
      .catch(error => {
        this.error(error);
      });
    },
    selectPlan(plan) {
      this.selected = plan;

      if (this.term == false) {
        this.plan = plan.monthly_price.id;
      } else {
        this.plan = plan.yearly_price.id
      }
      
      if (this.authenticated) {
        this.getIntent();
        this.step = 3;
      } else {
        this.step = 1;
      }
    },
    getCoupon() {
      axios.post(process.env.VUE_APP_API_BASE_URL + "/stripe/coupon", {
        coupon: this.$route.query.coupon
      })
      .then(response => {
        if (response.data.id) {
          this.coupon = response.data;
        }
      })
      .catch(error => {
        // 
      });
    },
    async checkCoupon() {
      await axios.post(process.env.VUE_APP_API_BASE_URL + "/stripe/validate-promocode", {
        promocode: this.promocode
      })
      .then(response => {
        if (response.data == false) {
          this.valid_coupon = false;
        } else {
          this.valid_coupon = true;
          this.coupon = response.data;
        }
      })
      .catch(error => {
        // 
      });
    },
    checkParams() {
      if (this.$route.query.affiliate) {
        this.model.affiliate = this.$route.query.affiliate;
      }

      if (this.$route.query.coupon) {
        this.getCoupon();
      }

      if (this.$route.query.pulse) {
        this.model.pulse = true;
      }

      if (this.$route.query.kwyp) {
        this.model.kwyp = true;
      }

      if (this.$route.query.via) {
        this.affiliateId = Rewardful.referral;
      }
    }
  },
  created() {
    this.getPlans();
    this.getStripeKey();
    this.checkParams();
  },
  watch: {
    step(to, from) {
      if (to == 3) {
        this.includeStripe('js.stripe.com/v3/', function(){
          this.configureStripe();
        }.bind(this));
      }
    }
  }
};
</script>
<style lang="scss">
.plans {
  .card-body {
    padding-top: 10px;
    background-image: url('/img/plans-background.png');
    background-size: 100% auto;
  }
  .card-title {
    margin-bottom: 0;
    font-size: 28px;
    font-weight: bold;
    text-shadow: 0px 0px 1px #222222;
    color: #CE5E5E;
  }
  h1 {
    text-transform: uppercase;
    font-weight: bold;
  }
  h5 {
    font-weight: bold;
    padding-top: 2px;
    padding-bottom: 2px;
    text-align: center;
    text-transform: uppercase;
  }

  ul {
    font-size: 13px;
    margin-bottom: 0.5rem;
    font-weight: normal;

    li {
      line-height: 19px;
    }
  }
}

.bg-light-blue {
  background-color: rgba(173, 216, 230, 0.3);

}
</style>
